module.exports = __webpack_public_path__ + "assets/physics.58111376.svg";